import { render, staticRenderFns } from "./pi-name-tooltip.vue?vue&type=template&id=00ffe3fc&"
import script from "./pi-name-tooltip.vue?vue&type=script&lang=ts&"
export * from "./pi-name-tooltip.vue?vue&type=script&lang=ts&"
import style0 from "./pi-name-tooltip.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports